import { Search, X } from "lucide-react";

export const SearchInput = ({ value, onChange, placeholder, testid, autoFocus }) => (
  <div className="relative">
    <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-500" />
    <input
      data-testid={testid}
      autoFocus={autoFocus}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full bg-[#0d1420] border border-slate-800 rounded-full pl-11 pr-10 py-3 text-sm text-slate-100 placeholder:text-slate-500 outline-none focus:border-sky-500 transition-colors"
    />
    {value && (
      <button
        type="button"
        data-testid={`${testid}-clear`}
        onClick={() => onChange("")}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-500 hover:text-sky-400 transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    )}
  </div>
);
